import axios from "axios";
import { $authHost } from ".";
import { getEndDate } from "@/utils/helpers";

export function getClubs(user_token?: string) {
  return $authHost.request({
    url: "/clubs",
    ...(user_token && { headers: { usertoken: user_token } }),
  });
}

export async function setTrainers(idClub: string, user_token: string) {
  return $authHost.get("/appointment_trainers_duty", {
    params: { club_id: idClub },
    headers: { usertoken: user_token },
  });
}

export async function setServices(idClub: string, user_token: string) {
  return $authHost.get("/appointment_services_duty", {
    params: { club_id: idClub },
    headers: { usertoken: user_token },
  });
}

export async function setDates(idClub: string, user_token: string) {
  return $authHost.get("/appointment_dates", {
    params: { club_id: idClub, end_date: getEndDate(2) },
    headers: { usertoken: user_token },
  });
}

export async function setSlots(idClub: string, user_token: string) {
  return $authHost.get("/appointment_times_duty", {
    params: { club_id: idClub, end_date: getEndDate(2) },
    headers: { usertoken: user_token },
  });
}

export async function getSlots(idClub: string, user_token: string) {
  const response = await $authHost.get("/appointment_times_duty", {
    params: { club_id: idClub, end_date: getEndDate(2) },
    headers: { usertoken: user_token },
  });
  return response.data.data;
}

export async function postAppointment(
  date_time: string,
  service_id: string,
  id_trener: string,
  room_id: string,
  idClub: string,
  user_token: string
) {
  return $authHost.post(
    "/appointment",
    {
      date_time,
      service_id,
      employee_id: id_trener,
      room_id,
      club_id: idClub,
    },
    { headers: { usertoken: user_token } }
  );
}

// External API - uses different base URL
export async function getClubInfo(idBranch: string) {
  const response = await axios.get(
    `${import.meta.env.VITE_API_CLUB_INFO_URL}:get?filter=${encodeURIComponent(
      JSON.stringify({ id_1c: idBranch })
    )}&appends=cabinet_posts`,
    {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `${import.meta.env.VITE_AUTHORISATION_CLUB_INFO}`,
      },
    }
  );
  return response.data;
}
